import { useStaticQuery, graphql } from 'gatsby';

const useOpeningHours = () => {
  const { openingHours } = useStaticQuery(graphql`
    query StrapiCompanyOpeningHoursQuery {
      openingHours: strapiCompanyOpeningHours {
        types {
          __typename
          ...on StrapiCompanyOpeningHoursTypeCompanyOpeningHoursByDay {
            id
            title
            monday
            tuesday
            wednesday
            thursday
            friday
            saturday
            sunday
          }
          ...on StrapiCompanyOpeningHoursTypeCompanyOpeningHoursByLine {
            id
            title
            lines {
              id
              title
              value
            }
          }
        }
      }
    }
  `);

  return {
    hasOpeningHours: (openingHours.types || []).length > 0,
    byDay: openingHours.types.filter(({ __typename }) => __typename === 'StrapiCompanyOpeningHoursTypeCompanyOpeningHoursByDay'),
    byLine: openingHours.types.filter(({ __typename }) => __typename === 'StrapiCompanyOpeningHoursTypeCompanyOpeningHoursByLine'),
  };
};

export default useOpeningHours;
